import React, { useEffect, useState } from 'react';
import './ProjectSection.css';
import { portfolioData, additionalProjects, personalProjects } from '../data/portfolioData';

const BLOG_URL = 'https://currentjob.github.io/devops-pipeline/';

// 블로그(Quartz) 글 목록. 날짜는 slug에 있는 YYYY-MM-DD를 쓰고, 라이프 글은 뺀다.
export function latestPosts(index, count = 3) {
  return Object.values(index)
    .map(post => ({ ...post, date: (post.slug.match(/\d{4}-\d{2}-\d{2}/) || [])[0] }))
    .filter(post => post.date && !post.slug.startsWith('라이프/'))
    .sort((a, b) => b.date.localeCompare(a.date))
    .slice(0, count);
}

function BlogPosts() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    if (typeof fetch !== 'function') return;
    fetch(`${BLOG_URL}static/contentIndex.json`)
      .then(res => (res.ok ? res.json() : {}))
      .then(index => setPosts(latestPosts(index)))
      .catch(() => {});
  }, []);
  if (!posts.length) return null;
  return <>
    <h3 className="portfolio-group-title">최근 블로그 글</h3>
    <div className="portfolio-secondary-grid">
      {posts.map(post => <article className="secondary-project" key={post.slug}>
        <p className="case-period">{post.date}</p>
        <h4><a href={BLOG_URL + encodeURI(post.slug)} target="_blank" rel="noreferrer">{post.title}</a></h4>
      </article>)}
    </div>
  </>;
}

function Tags({ items }) {
  return <div className="project-tech-row">{items.map(item => <span key={item} className="project-tech-tag">{item}</span>)}</div>;
}

export default function ProjectSection() {
  const [category, setCategory] = useState('전체');
  const categories = ['전체', ...new Set(portfolioData.map(project => project.category))];
  const projects = portfolioData.filter(project => category === '전체' || project.category === category);
  return (
    <section className="project-section section" id="portfolio">
      <div className="section-container">
        <div className="section-header">
          <span className="section-label">02 · Projects</span>
          <h2 className="section-title">프로젝트</h2>
          <p className="section-subtitle">회사에서 참여한 과제 위주로 정리했습니다. 어떤 문제가 있었고 어떻게 해결했는지 적어 두었습니다.</p>
        </div>
        <div className="project-filters" role="group" aria-label="프로젝트 분야">
          {categories.map(item => <button key={item} type="button" aria-pressed={category === item} onClick={() => setCategory(item)}>{item}</button>)}
        </div>
        <p className="project-count" aria-live="polite">주요 프로젝트 {projects.length}건</p>
        <div className="project-list">
          {projects.map((project, index) => (
            <article key={project.id} id={project.id} className="project-card case-study" aria-labelledby={`${project.id}-title`}>
              <div className="project-card-inner">
                <div className="project-index" aria-hidden="true">{String(index + 1).padStart(2, '0')}</div>
                <div className="project-card-content">
                  <div className="project-card-meta"><span className="project-category mono">{project.category}</span><span className="case-period">{project.period}</span></div>
                  <h3 className="project-title" id={`${project.id}-title`}>{project.title}</h3>
                  <p className="project-desc">{project.description}</p>
                  <p className="case-role">{project.role}</p>
                  {project.scale && <p className="case-scale">{project.scale}</p>}
                  <Tags items={project.tech} />
                  <ul className="case-outcomes">{project.outcomes.map(item => <li key={item}>{item}</li>)}</ul>
                  <details className="case-details">
                    <summary>구현 내용 보기<span className="sr-only"> — {project.title}</span></summary>

                    <h4>배경</h4><p>{project.problem}</p>
                    <h4>구현</h4><ul>{project.implementation.map(item => <li key={item}>{item}</li>)}</ul>
                    {project.validation && <><h4>확인한 내용</h4><p>{project.validation}</p></>}
                  </details>
                </div>
              </div>
            </article>
          ))}
        </div>
        <h3 className="portfolio-group-title">그 외에 참여한 과제</h3>
        <div className="portfolio-secondary-grid">
          {additionalProjects.map(project => <article className="secondary-project" key={project.title}>
            <p className="case-period">{project.period} · {project.role}</p><h4>{project.title}</h4><p>{project.description}</p>
          </article>)}
        </div>
        <h3 className="portfolio-group-title">개인 프로젝트</h3>
        <div className="portfolio-secondary-grid">
          {personalProjects.map(project => <article className="secondary-project" key={project.id}>
            <h4>{project.title}</h4><p>{project.description}</p><Tags items={project.tech} />
            <div className="project-links">
              <a className="demo-link" href={project.link} target="_blank" rel="noreferrer">사이트 열기 <span className="sr-only">— {project.title} (새 탭)</span> ↗</a>
              <a className="demo-link" href={project.source} target="_blank" rel="noreferrer">소스 보기 <span className="sr-only">— {project.title} GitHub 저장소 (새 탭)</span> ↗</a>
            </div>
          </article>)}
        </div>
        <BlogPosts />
      </div>
    </section>
  );
}
